import { useLocalStorage } from '../remote/local-storage'
import { axiosClient } from './axios'

const getBearer = () => {
  const { useFetchLocalStore } = useLocalStorage()
  const localStorage = useFetchLocalStore()?.token
  return `Bearer ${localStorage}`
}

type TypeUrl = 'base' | 'finance'

const url = import.meta.env.VITE_API_URL_FINANCEIRO
const financeBaseUrl = url || 'https://financeiro-cashfit.tecnologiagrupoopus.com.br/cashfit/v1/'

export const useRemoteClientDelete = (type: TypeUrl = 'base') => {
  const tokenBearer = getBearer()
  const remoteClientDelete = async (path: string, id: any) => {
    const config: any = {
      headers: {
        Authorization: tokenBearer
      }
    }

    if (type == 'finance') {
      config.baseURL = financeBaseUrl
    }

    const pathDelete = `${path}/${id}`
    const output = await axiosClient.delete(pathDelete, config)

    return output
  }

  return {
    remoteClientDelete
  }
}

export const useRemoteClientDeleteWithoutId = (type: TypeUrl = 'base') => {
  const tokenBearer = getBearer()
  const remoteClientDelete = async (path: string) => {
    const config: any = {
      headers: {
        Authorization: tokenBearer
      }
    }
    
    if (type == 'finance') {
      config.baseURL = financeBaseUrl
    }

    const output = await axiosClient.delete(path, config)

    return output
  }

  return {
    remoteClientDelete
  }
}

export const useRemoteClientGet = (type: TypeUrl = 'base') => {
  const tokenBearer = getBearer()
  const remoteClientGet = async (path: string, queryParams?: any, headers?: any) => {
    const config: any = {
      headers: {
        Authorization: tokenBearer,
        ...headers
      },
      params: queryParams
    }

    if (type == 'finance') {
      config.baseURL = financeBaseUrl
    }

    const output = await axiosClient.get(path, config)

    return output
  }

  return {
    remoteClientGet
  }
}

export const useRemoteClientPatch = (type: TypeUrl = 'base') => {
  const tokenBearer = getBearer()
  const httpClientPatch = async (path: string, body: any) => {
    const config: any = {
      headers: {
        Authorization: tokenBearer
      }
    }

    if (type == 'finance') {
      config.baseURL = financeBaseUrl
    }

    const output = await axiosClient.patch(path, body, config)
    return output
  }

  return {
    httpClientPatch
  }
}

export const useRemoteClientPost = (type: TypeUrl = 'base') => {
  const tokenBearer = getBearer()
  const httpClientPost = async (path: string, body: any) => {
    const config: any = {
      headers: {
        Authorization: tokenBearer
      }
    }

    if (type == 'finance') {
      config.baseURL = financeBaseUrl
    }

    const output = await axiosClient.post(path, body, config)
    return output
  }

  return {
    httpClientPost
  }
}

export const useRemoteClientPut = (type: TypeUrl = 'base') => {
  const tokenBearer = getBearer()
  const httpClientPut = async (path: string, body: any) => {
    const config: any = {
      headers: {
        Authorization: tokenBearer
      }
    }

    if (type == 'finance') {
      config.baseURL = financeBaseUrl
    }

    const output = await axiosClient.put(path, body, config)
    return output
  }

  return {
    httpClientPut
  }
}
